import { PlusIcon } from "@xola/icons";
import { Breadcrumb, Button, HeaderToolbar } from "@xola/ui-kit";
import React from "react";
import { useHistory } from "react-router-dom";
import { Permission } from "types";
import { IsGranted } from "../../components/Common/IsGranted";
import { SecondaryButton } from "../../components/Common/SecondaryButton";
import { ColumnLayout } from "../../components/Layout/ColumnLayout";
import { GuideManagement } from "../../components/Resources/GuideManagement/GuideManagement";
import { Page } from "../Page";
import { EmbeddedAppTriggerLocation } from "@/embeddedApps/EmbeddedAppTriggerLocation";

export const GuideManagementPage = () => {
    const history = useHistory();

    const handleSettingsClick = () => {
        history.push("/resources/guides/settings/permissions");
    };

    const handleClick = () => {
        history.push("/resources/guides/create");
    };

    return (
        <Page title="Guide Management">
            <ColumnLayout>
                <HeaderToolbar>
                    <HeaderToolbar.Breadcrumb className="mr-auto">
                        <Breadcrumb.Item>Resources</Breadcrumb.Item>
                        <Breadcrumb.Item>Guide Management</Breadcrumb.Item>
                    </HeaderToolbar.Breadcrumb>
                    <EmbeddedAppTriggerLocation id="resources.guides.headerBar" />
                    <IsGranted permissions={Permission.RESOURCES_GUIDES_ALL_VIEW}>
                        <SecondaryButton className="flex-shrink-0" onClick={handleSettingsClick}>
                            Global Settings
                        </SecondaryButton>

                        <Button color="primary" className="flex-shrink-0" icon={<PlusIcon />} onClick={handleClick}>
                            Add
                        </Button>
                    </IsGranted>
                </HeaderToolbar>
                <ColumnLayout.Fill>{(height) => <GuideManagement height={height} />}</ColumnLayout.Fill>
            </ColumnLayout>
        </Page>
    );
};
